export default "__VITE_ASSET__DMFUhwRk__"